import * as React from "react";
import { ReadOnlyFormGroup } from "components/common";
import { Well } from "components/bootstrap";
import usePluggableLicenseCheck from "hooks/usePluggableLicenseCheck";
import styles from "../event-notification-types/EmailNotificationSummary.css";
const EmailNotificationDetails = ({ notification }) => {
  var _a, _b;
  const recipients = /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Email Recipients",
      value: notification.config.email_recipients.join(", ") || "No email addresses are configured to receive this notification."
    }
  );
  const recipientLookupInfo = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Email Recipients Lookup Table Name", value: notification.config.recipients_lut_name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Email Recipients Lookup Table Key", value: notification.config.recipients_lut_key }));
  const ccEmails = /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "CC Emails",
      value: notification.config.cc_emails.join(", ") || "No email addresses are configured to be cc'd on this notification."
    }
  );
  const ccLookupInfo = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "CC Emails Lookup Table Name", value: notification.config.cc_emails_lut_name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "CC Emails Lookup Table Key", value: notification.config.cc_emails_lut_key }));
  const bccEmails = /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "BCC Emails",
      value: notification.config.bcc_emails.join(", ") || "No email addresses are configured to be bcc'd on this notification."
    }
  );
  const bccLookupInfo = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "BCC Emails Lookup Table Name", value: notification.config.bcc_emails_lut_name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "BCC Emails Lookup Table Key", value: notification.config.bcc_emails_lut_key }));
  const sender = /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Sender", value: notification.config.sender });
  const senderLookupInfo = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Sender Lookup Table Name", value: notification.config.sender_lut_name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Sender Lookup Table Key", value: notification.config.sender_lut_key }));
  const replyTo = /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Reply-To", value: notification.config.reply_to });
  const replyToLookupInfo = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Reply-To Lookup Table Name", value: notification.config.reply_to_lut_name }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Reply-To Lookup Table Key", value: notification.config.reply_to_lut_key }));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Send as Single Email", value: notification.config.single_email ? "Yes" : "No" }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Use Lookup Table for Sender",
      value: notification.config.lookup_sender_email ? "Yes" : "No"
    }
  ), notification.config.lookup_sender_email ? senderLookupInfo : sender, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Subject", value: notification.config.subject }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Use Lookup Table for Reply-To",
      value: notification.config.lookup_reply_to_email ? "Yes" : "No"
    }
  ), notification.config.lookup_reply_to_email ? replyToLookupInfo : replyTo, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "User Recipients",
      value: notification.config.user_recipients.join(", ") || "No users will receive this notification."
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Use Lookup Table for Email Recipients",
      value: notification.config.lookup_recipient_emails ? "Yes" : "No"
    }
  ), notification.config.lookup_recipient_emails ? recipientLookupInfo : recipients, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "CC Users",
      value: notification.config.cc_users.join(", ") || "No users will be cc'd on this notification."
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Use Lookup Table for CC Emails",
      value: notification.config.lookup_cc_emails ? "Yes" : "No"
    }
  ), notification.config.lookup_cc_emails ? ccLookupInfo : ccEmails, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "BCC Users",
      value: notification.config.bcc_users.join(", ") || "No users will be bcc'd on this notification."
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Use Lookup Table for BCC Emails",
      value: notification.config.lookup_bcc_emails ? "Yes" : "No"
    }
  ), notification.config.lookup_bcc_emails ? bccLookupInfo : bccEmails, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Time Zone", value: notification.config.time_zone }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Email Body",
      value: /* @__PURE__ */ React.createElement(Well, { bsSize: "small", className: styles.bodyPreview }, notification.config.body_template || /* @__PURE__ */ React.createElement("em", null, "Empty body"))
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Email HTML Body",
      value: /* @__PURE__ */ React.createElement(Well, { bsSize: "small", className: styles.bodyPreview }, notification.config.html_body_template || /* @__PURE__ */ React.createElement("em", null, "Empty body"))
    }
  ), ((_b = (_a = usePluggableLicenseCheck("/license/security")) == null ? void 0 : _a.data) == null ? void 0 : _b.valid) && /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Include Event Procedure in Email Body",
      value: notification.config.include_event_procedure ? "Yes" : "No"
    }
  ));
};
export default EmailNotificationDetails;
